import { adminRoutes } from 'modules/admin/routes/constants';

export const adminStaffRoutes = {
  root: `${adminRoutes.root}/staff`,
  staff: `${adminRoutes.root}/staff/staff`,
  users: `${adminRoutes.root}/staff/users`,
};
